/*
 *
 *  * Copyright(c) 2021 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { appConstants } from '@app/common/app-constants';
import { UtilService } from '@app/util/util.service';
import { BringOnline } from './bring-online';
import { StudyDataParam } from '@app/common/services/bring-online/bring-online.types';

export class TruePacsBringOnline extends BringOnline {
  protected constructor() {
    super();
  }

  getBringOnlineStatus(id, studyDataParam: StudyDataParam) {
    let fetchStatus;
    if (this.inProgress.indexOf(id) >= 0) {
      fetchStatus = appConstants.archiveAdoptionStatus.InProgress;
    } else if (this.error.indexOf(id) >= 0) {
      fetchStatus = appConstants.archiveAdoptionStatus.Error;
    } else {
      fetchStatus = studyDataParam.studyDataAvailability;
    }
    return fetchStatus;
  }

  getPopupParams(workItem) {
    // Show dialog only for Archived work item and yet to initiate download
    const bringOnlineStatus = this.getBringOnlineStatus(workItem.id, UtilService.fetchStudyDataParam(workItem));
    if (bringOnlineStatus === appConstants.studyDataAvailability.OFFLINE) {
      return {
        isDownloadable: true,
        isZeroImageExam: false
      };
    }
  }

  isOfflineExam(studyDataParam: any) {
    return studyDataParam.studyDataAvailability === appConstants.studyDataAvailability.OFFLINE;
  }

  isExamAvailable(workItem: any): boolean {
    const studyDataAvailability =
      workItem.studyDataAvailability !== undefined ? workItem.studyDataAvailability : workItem.availability;
    if (UtilService.isRemoteExam(workItem)) {
      return true;
    }
    if (this.inProgress.indexOf(workItem.id) >= 0 || this.error.indexOf(workItem.id) >= 0) {
      return false;
    }
    // exam is local
    return !this.isOfflineExam({ studyDataAvailability });
  }
}
